import { ActionIcon, Group, Text } from "@mantine/core";
import IconGripVertical from "@tabler/icons-react/dist/esm/icons/IconGripVertical.mjs";
import IconX from "@tabler/icons-react/dist/esm/icons/IconX.mjs";
import classes from "./Chip.module.scss";

/**
 * Generic chip used by data fields, group-by, and entity fields.
 */
export default function Chip({
  name,
  canEdit = false,
  drag = false,
  onDelete,
  rightSlot,
  optionsSlot,
  fullWidth = false,
}) {
  return (
    <Group
      gap={6}
      wrap="nowrap"
      className={`${classes.chip} ${fullWidth ? classes.fullWidth : ""}`}
    >
      {drag && (
        <IconGripVertical
          size={14}
          stroke={1.5}
          className={classes.gripIcon}
        />
      )}
      <Text size="sm" className={classes.label}>
        {name}
      </Text>
      {rightSlot}
      {(optionsSlot || canEdit) && (
        <Group gap={6} wrap="nowrap" ml="auto">
          {optionsSlot}
          {canEdit && (
            <ActionIcon
              variant="subtle"
              color="gray"
              size="sm"
              aria-label="Remove"
              onClick={(ev) => {
                ev.stopPropagation();
                onDelete?.();
              }}
            >
              <IconX size={14} stroke={1.5} />
            </ActionIcon>
          )}
        </Group>
      )}
    </Group>
  );
}
